import BlogSection from '../components/BlogSection';

export default function BlogPage() {
  return (
    <>
      <BlogSection />
    </>
  );
}
